import { render, staticRenderFns } from "./Dashboard-sidebar.vue?vue&type=template&id=dcbadaa2&scoped=true&"
import script from "./Dashboard-sidebar.vue?vue&type=script&lang=js&"
export * from "./Dashboard-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-sidebar.vue?vue&type=style&index=0&id=dcbadaa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbadaa2",
  null
  
)

export default component.exports